import FilterBarTemplate from "./FilterBarTemplate";

export default FilterBarTemplate;